export default function GtLogo(): JSX.Element {
  return (
    <div
      className="gt-logoIcon"
      style={{ backgroundImage: "url(/resources/gt-logo.svg)" }}
    ></div>
  );
}
